import { useEffect, useRef, useState } from 'react';
export const useBottom = ({ ref, onBottomReached }) => {
    const [bottomReached, setBottomReached] = useState(false);
    const bottomRef = useRef(null);
    useEffect(() => {
        bottomRef.current = ref.current?.querySelector('[data-pdf-bottom]');
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setBottomReached(true);
                    onBottomReached?.();
                    return;
                }
                setBottomReached(false);
            });
        });
        if (bottomRef.current) {
            observer.observe(bottomRef.current);
        }
        return () => {
            if (bottomRef.current) {
                observer.unobserve(bottomRef.current);
            }
        };
    }, [onBottomReached]);
    const handleScrollToBottom = event => {
        if (!(bottomRef.current instanceof HTMLElement)) {
            return;
        }
        // 'block: start' because the bottom content should be read from the start
        bottomRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    return { bottomReached, handleScrollToBottom };
};
//# sourceMappingURL=useBottom.js.map